/* DRESSFRESH 2026 · Scent story (sections/df-scent-story.liquid)
   Shows the scent block matching the option selected in the buy panel.
   Listens for `df:variant-change` (dispatched by assets/df-product.js) and matches
   detail.keys (handleized option values) against each block's data-scent-key.
   No match → first scent block. Theme editor: selecting a block shows it. */
(function () {
  'use strict';

  function activate(root, id) {
    if (!id || root.getAttribute('data-active') === id) return;
    root.setAttribute('data-active', id);
    root.querySelectorAll('[data-scent]').forEach(function (el) {
      var on = el.getAttribute('data-scent') === id;
      if (el.classList.contains('scenthero__slide')) {
        if (on) {
          /* restart the fade-up on the copy */
          el.classList.remove('is-active');
          void el.offsetWidth;
          el.classList.add('is-active');
          el.removeAttribute('aria-hidden');
        } else {
          el.classList.remove('is-active');
          el.setAttribute('aria-hidden', 'true');
        }
      } else {
        el.hidden = !on;
        if (on) {
          el.classList.remove('is-active');
          void el.offsetWidth;
          el.classList.add('is-active');
        } else {
          el.classList.remove('is-active');
        }
      }
    });
    root.querySelectorAll('[data-scent-pick]').forEach(function (btn) {
      var on = btn.getAttribute('data-scent-pick') === id;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      btn.setAttribute('tabindex', on ? '0' : '-1');
    });
  }

  function handleize(s) {
    return String(s || '').toLowerCase().trim()
      .replace(/['"]/g, '').replace(/[^a-z0-9À-ɏ]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* Scent switcher: pick the matching option in the buy panel so the cart matches what is
     shown (its df:variant-change then brings this section along). Without one, switch locally. */
  function pick(root, btn) {
    var id = btn.getAttribute('data-scent-pick');
    var key = btn.getAttribute('data-pick-key');
    var pid = root.getAttribute('data-product-id');
    var input = null;
    if (key) {
      document.querySelectorAll('[data-df-product] [data-df-option] input[type="radio"]').forEach(function (r) {
        if (input || handleize(r.value) !== key) return;
        var panel = r.closest('[data-df-product]');
        var json = panel && panel.querySelector('[data-df-product-json]');
        if (pid && json) {
          try { if (String(JSON.parse(json.textContent).id) !== pid) return; } catch (e) { /* ignore */ }
        }
        input = r;
      });
    }
    activate(root, id);
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function initSwitch(root) {
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-scent-pick]'));
    btns.forEach(function (btn, i) {
      btn.addEventListener('click', function () { pick(root, btn); });
      btn.addEventListener('keydown', function (e) {
        var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        var next = btns[(i + step + btns.length) % btns.length];
        pick(root, next);
        next.focus();
      });
    });
  }

  /* ordered list of { id, key } — one per scent block */
  function keyMap(root) {
    var map = [];
    var seen = {};
    root.querySelectorAll('[data-scent-key]').forEach(function (el) {
      var id = el.getAttribute('data-scent');
      if (!seen[id]) { seen[id] = true; map.push({ id: id, key: el.getAttribute('data-scent-key') }); }
    });
    return map;
  }

  function onVariant(root, detail) {
    if (!detail) return;
    var pid = root.getAttribute('data-product-id');
    if (pid && detail.productId && String(detail.productId) !== pid) return;
    var keys = detail.keys || [];
    var map = keyMap(root);
    if (!map.length) return;
    var match = null;
    map.forEach(function (m) { if (!match && m.key && keys.indexOf(m.key) > -1) match = m; });
    activate(root, (match || map[0]).id);
  }

  function init(root) {
    if (root.dataset.dfScentReady) return;
    root.dataset.dfScentReady = '1';
    initSwitch(root);
    document.addEventListener('df:variant-change', function (e) {
      if (!root.isConnected) return;
      onVariant(root, e.detail);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-df-scent]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var root = target.closest('[data-df-scent]');
    if (!root) return;
    var id = target.getAttribute('data-scent');
    if (id) activate(root, id);
  });
})();
